
import Vue from 'vue';
import LinkHandler from '@core/components/helpers/LinkHandler.vue';
import SocialLinks from '@root/common/components/base/SocialLinks.vue';
import { Footer } from '@root/modules/navigation/types/navigation';

interface Props {
  navigation: Footer;
  isEasyChannel: boolean;
}

export default Vue.extend<unknown, unknown, unknown, Props>({
  components: {
    LinkHandler,
    SocialLinks,
  },
  props: {
    navigation: {
      type: Object,
      required: true,
    },
    isEasyChannel: {
      type: Boolean,
      required: true,
    },
  },
});
